export const DEFAULT_PAGINATION_LIMIT = 25

/**
 * Page size for a list nested inside an expanded table row. Bigger than a page's own default,
 * because the row was opened to read exactly that list.
 */
export const SUBLIST_PAGINATION_LIMIT = 50

/**
 * Page size for a searchable select's dropdown.
 *
 * Big enough that "select all" over what is loaded is usually the whole list, small enough
 * that opening a dropdown is one modest request. The list endpoints cap a page at
 * `MAX_LIST_LIMIT`, so no select can ever hold everything by asking once.
 */
export const SELECT_PAGE_LIMIT = 200

export const MAX_LIST_LIMIT = 600

export const SEARCH_DEBOUNCE_MS = 300
